import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface PreFilterStore {
  shouldShowPreFilter: boolean
  setShouldShowPreFilter: (preFilter: boolean) => void
}

export const usePreFilterStore = create<PreFilterStore>()(
  devtools((set) => ({
    shouldShowPreFilter: false,
    setShouldShowPreFilter(preFilter) {
      set({ shouldShowPreFilter: preFilter }, false, 'setShouldShowPreFilter')
    }
  }))
)
